import { Link } from "react-router-dom";
function Projects({data}) {
    
    return(
      
        <main className="projects">
          <h1>projects :</h1>
          <div>

        {data.map((item)=>{
            return(
                   <Link to={item.url} target="_blank">
                    <div className="project-coulmn">
                        
                        <img src={`images${item.img}`} />
                    <h1>{item.title}</h1>
                    <div className="lang">

                    {item.lang?item.lang.map((item)=><div><h1>{item}</h1></div>):""}
                    </div>
                </div>
                   </Link>
            ) 
        })}
               </div>
      </main>
    )
}
export default Projects;
